import type { Venue } from '../../types/venue';

export const jacyzHotel: Venue = {
  id: 'jacyz-hotel',
  name: "Jacy'z Hotel & Resort",
  image: '/assets/images/jacyz-hotel.jpg',
  address: 'Drakegatan 10, 412 50 Göteborg, Sweden',
  coordinates: {
    lat: 57.705596,
    lng: 11.992388
  },
  capacity: {
    min: 10,
    max: 500
  },
  rating: 5.0,
  reviews: Array.from({ length: 1360 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 5.0,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'pool', 'spa'],
  images: [
    '/assets/images/jacyz-hotel.jpg',
    'https://www.byggnyheter.se/sites/default/files/media-cover-images/jacy_z_pressrelease_arets_byggnad_00.jpg',
    'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&q=80&w=1000',
  ],
  description: {
    en: `<p>WELCOME TO JACY'Z, your go-to place for meetings, kickoffs, celebrations and special occasions. A venue for both work and play where you'll want to hang out long after office hours.</p>
    
    <p>Jacy'z offers impressive meeting rooms in a stunning 100-meter high skyscraper with numerous exciting areas. Enjoy breathtaking city views from the 27th floor, relax at our Miami-inspired pool club with an ice-cold cocktail after a week of meetings, savor our American Italian cuisine, or discover our hidden speakeasy bar.</p>
    
    <p>Our modern meeting facilities are located on floors 3, 4, and 24, featuring state-of-the-art technology and convenient breakout areas. With three restaurants, five bars, and a rooftop pool club 100 meters above ground, there's something for everyone.</p>
    
    <p>The newly opened Jacy'z Big Stage is the region's most luxurious venue for lectures, shows, and cinema screenings, with nearly 500 square meters of space, 9-meter ceilings, and cutting-edge technology.</p>
    
    <p>Our 233 sophisticated rooms include 41 premium "JQ" rooms with their own unique concept and exclusive experience. After your visit, you'll feel like you've explored a major city – with that urge to return because there's still so much to discover.</p>`,
    sv: `<p>VÄLKOMMEN TILL JACY'Z, ditt go-to place för möten, kickoffs, celebrations och högtider. En plats för både work och play där du vill hänga långt efter office hours.</p>
    
    <p>På Jacy'z har vi imponerande mötesrum i en 100 meter hög skyskrapa med många spännande ytor. Njut av den svindlande utsikten från 27:e våningen, koppla av vid vår Miami-inspirerade pool club med en iskall drink efter en veckas möten, smaka vår American Italian-meny, eller upptäck vår hemliga speakeasybar.</p>
    
    <p>Våra moderna möteslokaler finns på plan 3, 4 och 24 med toppmodern teknik och bekväma breakout-ytor. Med tre restauranger, fem barer och en takpool 100 meter ovan mark finns här något för alla.</p>
    
    <p>Den nyöppnade Jacy'z Big Stage är regionens mest luxuösa sal för föreläsningar, shower och biovisningar, med närmare 500 kvadratmeter, 9 meter i tak och den senaste tekniken.</p>
    
    <p>Våra 233 sofistikerade rum inkluderar 41 premium "JQ"-rum med eget unikt koncept och exklusiv upplevelse. Efter ditt besök kommer du ha samma känsla som när du reser från en storstad – att du inte hunnit se allt och bara måste komma tillbaka.</p>`,
    no: `<p>VELKOMMEN TIL JACY'Z, ditt foretrukne sted for møter, kickoffs, feiringer og spesielle anledninger. Et sted for både arbeid og fritid hvor du vil henge lenge etter arbeidstid.</p>
    
    <p>Jacy'z tilbyr imponerende møterom i en imponerende 100-meter høy skyskraper med mange spennende områder. Nyt fantastisk utsikt over byen fra 27. etasje, slapp av ved vår Miami-inspirerte bassengklubb med en iskald cocktail etter en uke med møter, nyt vårt amerikansk-italienske kjøkken, eller oppdag vår skjulte speakeasy-bar.</p>
    
    <p>Våre moderne møtefasiliteter ligger i etasjene 3, 4 og 24, med toppmoderne teknologi og praktiske pauseområder. Med tre restauranter, fem barer og en takterrasse med basseng 100 meter over bakken, er det noe for enhver smak.</p>
    
    <p>Den nyåpnede Jacy'z Big Stage er regionens mest luksuriøse arena for forelesninger, show og kinovisninger, med nesten 500 kvadratmeter, 9 meter i takhøyde og banebrytende teknologi.</p>
    
    <p>Våre 233 sofistikerte rom inkluderer 41 premium "JQ"-rom med sitt eget unike konsept og eksklusiv opplevelse. Etter besøket vil du føle som om du har utforsket en storby – med en trang til å komme tilbake fordi det fortsatt er så mye å oppdage.</p>`,
    da: `<p>VELKOMMEN TIL JACY'Z, dit foretrukne sted til møder, kickoffs, fejringer og særlige begivenheder. Et sted til både arbejde og leg, hvor du vil hænge ud længe efter arbejdstid.</p>
    
    <p>Jacy'z tilbyder imponerende mødelokaler i en imponerende 100-meter høj skyskraber med mange spændende områder. Nyd betagende udsigt over byen fra 27. etage, slap af ved vores Miami-inspirerede poolklub med en iskold cocktail efter en uge med møder, nyd vores amerikansk-italienske køkken, eller opdag vores skjulte speakeasy-bar.</p>
    
    <p>Vores moderne mødefaciliteter er placeret på etagerne 3, 4 og 24, med topmoderne teknologi og praktiske pauseområder. Med tre restauranter, fem barer og en tagterrasse med pool 100 meter over jorden, er der noget for enhver smag.</p>
    
    <p>Den nyåbnede Jacy'z Big Stage er regionens mest luksuriøse venue til forelæsninger, shows og biografvisninger, med næsten 500 kvadratmeter, 9 meter til loftet og banebrydende teknologi.</p>
    
    <p>Vores 233 sofistikerede værelser inkluderer 41 premium "JQ"-værelser med deres eget unikke koncept og eksklusiv oplevelse. Efter dit besøg vil du føle som om du har udforsket en storby – med en trang til at komme tilbage, fordi der stadig er så meget at opdage.</p>`
  },
  priceRange: {
    min: 2500,
    max: 15000
  },
  recommended: true,
  country: 'se',
  region: 'gothenburg',
  city: 'Gothenburg',
  factbox: {
    rooms: 233,
    conferenceRooms: 34,
    restaurantCapacity: 220,
    features: [
      '100-meter high skyscraper',
      'Two pool clubs including rooftop',
      'Big Stage (500 sqm venue)',
      '5 bars, 4 restaurants',
      'Spa with panorama sauna',
      'Live music'
    ]
  }
};